import { PluginObject } from 'vue';
import { TextHelpers } from '../utils/textHelpers';
import type { IInternationalText } from '@license-manager/types';

declare module 'vue/types/vue' {
  interface Vue {
    $getLocalizedText(item: IInternationalText, language: string, fallbackLanguage?: string): string;
  }
}

export const TextHelpersPlugin: PluginObject<void> = {
  install(Vue) {
    Vue.prototype.$getLocalizedText = TextHelpers.getLocalizedText;
  }
};

export default TextHelpersPlugin;
